import type { Underlying } from 'models/underlying';
import type { UnderlyingCodeType } from 'models/underlying/base';
import { connect } from 'react-redux';
import { getUserPreferencesUnderlyingCodeType } from 'state/selectors';
import type { AppState } from 'state/state.model';

export interface ReferenceValue {
  reference: string;
  value: number;
}

export interface SpotAndGreeks {
  underlying?: Underlying;
  spot?: number;
  deltaPct?: number;
  vega?: number;
  vegaEuro?: number;
  deltaInShare?: number;
  isForex?: boolean;
  fxDelta?: ReferenceValue;
  fxVega?: ReferenceValue;
}
export interface SpotAndGreeksFieldOwnProps {
  id: string;
  className?: string;
  value?: SpotAndGreeks[];
  tabIndex?: number;
}

interface SpotAndGreeksFieldStateProps {
  defaultUnderlyingCodeType: UnderlyingCodeType;
}

export type SpotAndGreeksFieldProps = SpotAndGreeksFieldOwnProps & SpotAndGreeksFieldStateProps;

export const mapStateToProps = (state: AppState): SpotAndGreeksFieldStateProps => {
  const defaultUnderlyingCodeType = getUserPreferencesUnderlyingCodeType(state);
  return { defaultUnderlyingCodeType };
};

export const connectMultipleUnderlingComponent = connect(mapStateToProps);
